<mat-card>
   <form #loginForm="ngForm">
   <mat-toolbar>
    {{'utes.titol' | translate }}
    <div style="width:100%;float:right">
      <button mat-icon-button style="float: right; margin-left: 5px" (click)="close()" matTooltip="{{('utes.tancar') | translate}}" attr.aria-label="{{('utes.tancar') | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">close</mat-icon>
      </button>
      <button *ngIf="rol == 2 || rol == 4" mat-icon-button style="float: right; margin-right: 0" (click)="desar()" matTooltip="{{('utes.desar') | translate}}" attr.aria-label="{{('utes.desar') | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
      </button>
    </div>
   </mat-toolbar>
   <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
   <mat-card-content style="float:left;clear:both;padding:24px;padding-bottom:0px;padding-top:0px;width:95%">
      <mat-form-field style="float:left;clear:none;padding-top:20px;color:black;width:3%">
        <input matInput name="id" [(ngModel)]="editUtesData.id" placeholder="{{('utes.cmpid') | translate}}" disabled/>
      </mat-form-field>
       <mat-form-field style="float:left;clear: none;width:20%;padding-top:20px;color:black">
        <input matInput type="text" [(ngModel)]="editUtesData.codi" name="codi" placeholder="{{('utes.codi') | translate}}">
      </mat-form-field>
      <mat-form-field style="float:left;clear: none;width:70%;padding-top:20px;color:black">
        <input matInput type="text" [(ngModel)]="editUtesData.nom" name="nom" placeholder="{{('utes.nom') | translate}}">
      </mat-form-field>
      <mat-form-field style="float:left;clear: left;width:15%;padding-top:20px;color:black">
        <input matInput type="text" [(ngModel)]="editUtesData.nif" name="nif" placeholder="{{('utes.cmpnif') | translate}}">
      </mat-form-field>
      <mat-form-field style="float:left;clear: none;width:20%;padding-top:20px;color:black">
        <input matInput type="text" [(ngModel)]="editUtesData.compte" name="compte" placeholder="{{('utes.cmpcompte') | translate}}">
      </mat-form-field>
      <mat-form-field style="float:left;clear: none;width:60%;padding-top:20px;color:black">
        <input matInput type="text" [(ngModel)]="editUtesData.codi1" name="codi1" placeholder="{{('utes.cmpcodi1') | translate}}" [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let codi of tbCodis" [value]="codi.codi">{{codi.nom}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field style="float:left;left: none;width:45%;padding-top:20px;color:black">
        <input matInput type="text" [(ngModel)]="editUtesData.gerent" name="gerent" placeholder="{{('utes.cmpgerent') | translate}}">
      </mat-form-field>
      <mat-form-field style="float:left;clear: none;width:25%;padding-top:20px;color:black">
        <input matInput type="text" [(ngModel)]="editUtesData.gestiona" name="gestiona" placeholder="{{('utes.cmpgestiona') | translate}}">
      </mat-form-field>
    </mat-card-content>
    <mat-card-content style="float:left;clear:both;padding:24px;padding-bottom:0px;padding-top:0px;width:95%">
      <mat-form-field style="float: left;none: left;width:130px">
        <input matInput placeholder="{{('utes.cmpalta') | translate}}" [(ngModel)]="editUtesData.alta" name="alta" type="date"/>
      </mat-form-field> 
      <mat-form-field style="float: left;clear: none;width:130px;margin-left:20px">
        <input matInput placeholder="{{('utes.cmpinoperativa') | translate}}" [(ngModel)]="editUtesData.inoperativa"  name="inoperativa" type="date"/>
      </mat-form-field>
      <mat-form-field style="float: left;clear: none;width:130px;margin-left:20px">
        <input matInput placeholder="{{('utes.cmpbaixa') | translate}}" [(ngModel)]="editUtesData.baixa"  name="baixa" type="date"/>
      </mat-form-field>
      <mat-form-field style="float: left;clear: none;width:130px;margin-left:20px">
        <input matInput placeholder="{{('utes.cmpcaducitat_digital') | translate}}" [(ngModel)]="editUtesData.caducitat_digital" name="caducitat_digital" type="date"/>
      </mat-form-field>
      <mat-form-field style="float: left;clear: none;width:85px;margin-left:20px;color:black">
        <input matInput type="number" step="1" placeholder="{{('utes.cmpcapi_social') | translate}}" style="width:90%" name="capital_social" [(ngModel)]="editUtesData.capital_social"  title="{{('utes.cmpcapi_social') | translate}}"/>
      </mat-form-field>
      <mat-form-field style="float: left;clear: none;width:60px;margin-left:20px;color:black">
        <input matInput type="number" min="0" max="100" step="1" placeholder="{{('utes.cmpperc_propi') | translate}}" style="width:100%" name="percent_propi" [(ngModel)]="editUtesData.percent_propi" title="{{('utes.cmpperc_propi') | translate}}"/>
      </mat-form-field>
   </mat-card-content>

   <mcrit-gestio-manage-utes-socis-list style="float:left;clear:both;width:100%"
    [showAsyncProgress]="showAsyncProgress"
    [clientsSocisList]="utesSocis"
    [idUTEs]="editUtesData.codi"
    (changeFilter)="setSocisUtes()"
    class="equiWColElement">
   </mcrit-gestio-manage-utes-socis-list>

  </form>
 </mat-card>
